export default __webpack_public_path__ + "static/media/something-went-wrong.9581dfb8.svg";